// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import MuralPage from "./MuralPage";
import GalleryPage from "./GalleryPage";
import AdminLogin from "./AdminLogin";

function App() {
  const [isAdmin, setIsAdmin] = useState(false);

  return (
    <Router>
      <nav style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>
        <Link to="/" style={{ marginRight: "10px" }}>Home</Link>
        <Link to="/gallery" style={{ marginRight: "10px" }}>Gallery</Link>
        {/* <Link to="/admin">Admin</Link> */}
      </nav>

      <Routes>
        <Route
          path="/"
          element={<MuralPage isAdmin={isAdmin} setIsAdmin={setIsAdmin} />}
        />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route
          path="/admin"
          element={<AdminLogin setIsAdmin={setIsAdmin} />}
        />
      </Routes>
    </Router>
  );
}

export default App;

